import { graphql } from '@graphql/gql';

export const GET_EVENT_LOCALES_INFO = graphql(`
  query GET_EVENT_LOCALES_INFO($eventId: ID, $environment: String) {
    eventLocaleInfo(eventId: $eventId, environment: $environment) {
      browserLocaleDetection
      supportedEventLocales {
        localeId
        languageName
        languageCountry
        isDefault
        cultureCode
      }
    }
  }
`);
